import React from 'react'
import { Alert } from '@mantine/core'

export const ImportantNote: React.FC = ({ children }) => {
  return (
    <Alert
      icon={<div>&#x270D;</div>}
      styles={{ root: { backgroundColor: 'transparent !important' } }}
    >
      {children}
    </Alert>
  )
}
